import { useMemo } from "react";
import { useTheme } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core";
import { useAtomicStyles } from "styles";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    mainContainer: {
      margin: "2em",
      // padding: "1em",
      borderRadius: "15px",
      backgroundColor: "white",
      width: "70vw",
      maxWidth: "1000px",
      [theme.breakpoints.down("sm")]: {
        width: "100vw",
        maxWidth: "500px",
      },
    },
    formLogo: {
      alignSelf: "center",
      width: "80%",
    },
    imageContainer: {
      height: "100%",
      [theme.breakpoints.down("sm")]: {
        display: "none",
      },
    },
    formLeftImg: {
      width: "100%",
    },
  }),
);

const useAuthenticationContainer = () => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const classes = useMemo(() => ({}), []);
  const atomicStyles = useAtomicStyles();

  return {
    styles,
    classes,
    atomicStyles,
  };
};

export { useAuthenticationContainer as default };
